import React, { useEffect, useState } from "react";
import analytics from "../../../context/analytics";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { logEvent } from "firebase/analytics";

// components
import { BookmarkOutlineIcon, ShareIcon } from "../../../components/svgs";
import { BackButton } from "../../../components/common";
import { ConfirmModal } from "../../../components/motivational/";
import { MotivationalCarousel } from "../../../components/motivational/";
import {
  MainHolder,
  Children,
  Body,
  StyledText,
} from "../../../components/common/basic";

// context
import { useMotivational } from "../../../hooks";

const SavedQuoteScreen = () => {
  const history = useHistory();

  const { removeBookmark, bookmarkedItems, getUserMotivationalQuotes } =
    useMotivational();

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "Saved Quote Screen",
        firebase_screen_class: "SavedQuoteScreen",
      })
    );

    getUserMotivationalQuotes();
  }, []);

  useEffect(() => {
    if (bookmarkedItems) {
      setActiveMotivation(bookmarkedItems[0]);
    }
  }, [bookmarkedItems]);

  const [activeMotivation, setActiveMotivation] = useState();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {showModal && (
        <ConfirmModal
          handleOnConfirm={() => {
            removeBookmark(activeMotivation);
            setShowModal(false);
          }}
          hideModal={() => {
            setShowModal(false);
          }}
          title={"Remove quote"}
          description={
            "Are you sure you want to remove this quote from your saved list?"
          }
        />
      )}
      <MainHolder style={{ padding: 0, margin: 0 }}>
        <Children style={{ padding: 0, margin: 0 }}>
          <div style={{ padding: 0 }}>
            <BackButton onClick={() => history.goBack()} />

            <StyledText
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                marginLeft: "30%",
              }}
            >
              Saved Quotes
            </StyledText>
          </div>

          <Body style={{ margin: 0, padding: 0 }}>
            <MotivationalCarousel
              onChange={(index) => {
                setActiveMotivation(bookmarkedItems[index]);
              }}
              motivations={bookmarkedItems}
            />
            {bookmarkedItems?.length > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <IconContainer
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  <BookmarkOutlineIcon isOutline={false} />
                </IconContainer>
                <IconContainer
                  onClick={() => {
                    history.push(
                      `/referral/share?message=${
                        activeMotivation.message
                      } ${"https://nextgen.onelink.me/LVCI/hhsdmnrd"}`
                    );
                  }}
                >
                  <ShareIcon />
                </IconContainer>
              </div>
            )}
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const IconContainer = styled.div`
  border: 1px solid #d9d9d9;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  margin-left: 10px;
`;

export default SavedQuoteScreen;
